import { useQuery } from '@tanstack/react-query';
import { getUserStats } from '../services/gameService';

interface GameTypeStats {
  games_played: number;
  total_score: number;
  high_score: number;
}

export interface UserStats {
  total_score: number;
  games_played: number;
  high_score: number;
  average_score: number;
  by_game_type: Record<string, GameTypeStats>;
}

export const useUserStats = () => {
  const { data: stats, isLoading, error } = useQuery({
    queryKey: ['userStats'],
    queryFn: getUserStats,
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
    gcTime: 1000 * 60 * 30, // Keep in cache for 30 minutes
  });

  return { 
    stats, 
    isLoading, 
    error: error ? (error as Error).message : null 
  };
}; 